import classNames from "classnames/bind";
import { IconProps } from "common/assets/icons/types";
import * as React from "react";
import styles from "./Icon.module.css";

const classNameBuilder = classNames.bind(styles);

export const BooksIcon: React.FC<IconProps> = ({
  color = "#fd6a65",
  withBackground,
}) => {
  const renderContent = (): React.JSX.Element => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h32v32H0z" />
          <g transform="translate(4.5 5.435)">
            <rect
              fill={color}
              opacity=".12"
              y=".565"
              width="7"
              height="20"
              rx="2"
            />
            <rect
              fill={color}
              opacity=".12"
              x="5.5"
              y=".565"
              width="7"
              height="20"
              rx="2"
            />
            <rect
              stroke={color}
              strokeWidth="1.5"
              x=".75"
              y="1.315"
              width="5.5"
              height="18.5"
              rx="2"
            />
            <path fill={color} d="M1 4.565h11v1.2H1zM1 14.565h11v1.2H1z" />
            <rect
              stroke={color}
              strokeWidth="1.5"
              x="6.25"
              y="1.315"
              width="5.5"
              height="18.5"
              rx="2"
            />
            <g transform="rotate(-15 12.63 -42.77)">
              <rect fill={color} opacity=".12" width="7" height="20" rx="2" />
              <path fill={color} d="M.5 4h6v1.2h-6zM.5 14h6v1.2h-6z" />
              <rect
                stroke={color}
                strokeWidth="1.5"
                x=".75"
                y=".75"
                width="5.5"
                height="18.5"
                rx="2"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  };

  if (withBackground) {
    return (
      <div
        className={classNameBuilder({
          withBackground,
        })}
      >
        {renderContent()}
      </div>
    );
  }

  return renderContent();
};
